import { useTranslation } from 'react-i18next';
import { IChatMessage } from 'services/chat/types';
import { useSoundEffect } from './useSoundEffect';

export const useNotification = () => {
  const { t } = useTranslation();

  const play = useSoundEffect();

  // const notification = (notification: INotification) => {
  //   new Notification(t(`notifications.${notification.resource}.header`), {});

  //   play();
  // };

  const message = (message: IChatMessage) => {
    new Notification('Support', {
      body: message.body,
    });

    play();
  };

  return { message };
};
